// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-delete-content[data-v-5bc05270]{grid-gap:1rem;gap:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
